module.exports = __webpack_public_path__ + "img/veil_nebula_rev2_thumb.6c975dd2.jpg";